import { render, staticRenderFns } from "./customerRelations.vue?vue&type=template&id=349ce6bd&scoped=true"
import script from "./customerRelations.vue?vue&type=script&lang=js"
export * from "./customerRelations.vue?vue&type=script&lang=js"
import style0 from "./customerRelations.vue?vue&type=style&index=0&id=349ce6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ce6bd",
  null
  
)

export default component.exports